// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// Your Firebase project configuration
// You'll need to replace these with your actual Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyCeg74R_1py9pIQyORzs6fFCtElr5YqdZ4",
  authDomain: "time-tracker-8f267.firebaseapp.com",
  projectId: "time-tracker-8f267",
  storageBucket: "time-tracker-8f267.firebasestorage.app",
  messagingSenderId: "40389732811",
  appId: "1:40389732811:web:41fad272e1a4c315d3ee4e",
  measurementId: "G-XW7Z7GM3NE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);

// Connect to emulators in development (optional)
if (process.env.NODE_ENV === 'development') {
  // Uncomment these lines if you want to use Firebase emulators for development
  // connectFirestoreEmulator(db, 'localhost', 8080);
  // connectAuthEmulator(auth, 'http://localhost:9099');
}

export default app;
